class FP_Preload {
	constructor() {
		if (!window.IntersectionObserver) {
			return;
		}

		this.preload_items = document.querySelectorAll('.fp-preload');
		if (!this.preload_items.length) {
			return;
		}

		this.init();
	}
	
	init() {
		const self = this;

		this.preload_items.forEach(function(item) {
			const observer = new IntersectionObserver((entries) => {
				self.observerCallback(entries, observer)
			},
			{threshold: 0.1});

			observer.observe(item);
		});
	}

	observerCallback(entries, observer) {
		entries.forEach((entry, i) => {
			if (!entry.isIntersecting) {
				return;
			}

			if (entry.target.dataset.callbackFunction) {
				new Function(entry.target.dataset.callbackFunction).call(entry.target);
			}
		});
	}
}